import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

require('material-design-lite')

Vue.config.productionTip = false

window.axios = axios.create({
  baseURL: 'https://gjg7d9i2k4.execute-api.eu-west-2.amazonaws.com/production'
})

Vue.mixin({
  methods: {
    componentHandler () {
      this.$nextTick(() => {
        window.componentHandler.upgradeAllRegistered()
        window.componentHandler.upgradeDom()
      })
    }
  },
  mounted () {
    this.componentHandler()
  }
})

Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
  data: {
    passedLogin: false,
    passedPayload: false,
    showSnackbar: false,
    snackbarText: '',
    additionalCss: ''
  },
  computed: {
    loading () {
      return !this.passedLogin || !this.passedPayload
    }
  },
  methods: {
    getCoreDirectoryClientId (identifier) {
      return window.axios.get(`${this.$store.getters.coreDirectoryEndpoint}/get-client-id?identifier=${identifier}`)
    },
    loadCss () {
      delete window.axios.defaults.headers.common['Authorization']
      return window.axios.get(`https://portal-additional-assets.s3.eu-west-2.amazonaws.com/${this.$store.getters.user.client_id}/additional_css.css`)
    },
    finishLogin () {
      this.getCoreDirectoryClientId(this.$store.getters.user.username)
        .then(response => {
          let user = this.$store.getters.user
          user.client_id = response.data[0].client_id
          this.$store.commit('setUser', user)
          let token = localStorage.getItem('accessToken')

          if (token) {
            this.$store.commit('accessToken', token)
          }

          this.passedLogin = true
          this.passedPayload = true
        })
    }
  },
  mounted () {
    let storageUser = localStorage.getItem('user')

    if (storageUser) {
      this.$store.commit('setUser', JSON.parse(storageUser))
      this.finishLogin()
    } else {
      window.axios.get('https://vp20cmrss5.execute-api.eu-west-2.amazonaws.com/Dev', {
        params: {
          domain: window.location.hostname,
          system: 'documentStorage'
        }
      }).then(response => {
        if (!this.passedLogin && response.data.loginUrl) {
          return window.location.replace(response.data.loginUrl)
        }
      })
    }
  }
}).$mount('#app')
